import Vue from "vue";
import vuexI18n from "vuex-i18n";
import App from "./App";
import FormComponentsMixin from "@/shared/components/FormComponentsMixin";
import danishForm from "./translations/form/da_form.json";
import danishContract from "./translations/contract/da_contract.json";

import "@/shared/assets/css/general-styles.css";
import "@/shared/assets/css/contract-style.css";
import { store } from "./store";

/* Set up initial translations */
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add("da-DK", {
  ...danishForm,
  ...danishContract
});
Vue.i18n.set("da-DK");

Vue.config.productionTip = false;

/* Globally register the shared functionality mixin. Observe this carefully, as this may affect any 3rd party vue plugins. */
Vue.mixin(FormComponentsMixin);

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
